import client from './client';

export const packagesApi = {
  create(data) {
    return client.post('/packages', data);
  },
  createBatch(data) {
    return client.post('/packages/batch', data);
  },
  accept(id) {
    return client.patch(`/packages/${id}/accept`);
  },
  reject(id) {
    return client.patch(`/packages/${id}/reject`);
  },
  getAll(params = {}) {
    return client.get('/packages', { params });
  },
  getById(id) {
    return client.get(`/packages/${id}`);
  },
  update(id, data) {
    return client.patch(`/packages/${id}`, data);
  },
  updateStatus(id, status) {
    return client.patch(`/packages/${id}/status`, { status });
  },
  delete(id) {
    return client.delete(`/packages/${id}`);
  },
};

